module.exports = __webpack_public_path__ + "04_hige_white.9f2290ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer3/04_hige_white.png
// module id = Ueqk
// module chunks = 0